/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_DescriptionInputs */

const en_directory_hubs_signals_description = /** @type {(inputs: Directory_Hubs_Signals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Seek AI scores every product: the AI-Ready and GEO benchmarks, how they are measured, and why they matter.`)
};

const zh_directory_hubs_signals_description = /** @type {(inputs: Directory_Hubs_Signals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 如何为每个产品评分：AI-Ready 与 GEO 两套基准如何测量、为何重要。`)
};

/**
* | output |
* | --- |
* | "How Seek AI scores every product: the AI-Ready and GEO benchmarks, how they are measured, and why they matter." |
*
* @param {Directory_Hubs_Signals_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_description = /** @type {((inputs?: Directory_Hubs_Signals_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_description(inputs)
	return zh_directory_hubs_signals_description(inputs)
});
export { directory_hubs_signals_description as "directory.hubs.signals.description" }